import {
    type ServicePricePayload,
    type ServicePriceResponse,
    parseServicePriceApiResponse,
} from '@repo/types/service-price';
import { fetcher } from '@repo/utils';

import { type ServicesBasePath } from './services.utils';

export const getServicePrice = async (
    servicesBasePath: ServicesBasePath,
    payload: ServicePricePayload
): Promise<ServicePriceResponse> => {
    const url = `${servicesBasePath}/service-price/v2`;
    const response = await fetcher(url, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    const data = await response.json();
    return parseServicePriceApiResponse(data);
};
